import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export default function GlassCard({ children }: Props) {
  return (
    <div className="rounded-none sm:rounded-3xl border border-brand-100/80 bg-gradient-to-br from-brand-100/90 via-white/80 to-accent-100/80 p-4 shadow-2xl shadow-brand-200/30 sm:p-8 lg:p-10">
      {children}
    </div>
  );
}
